import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c9269c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "appeal-box" }
const _hoisted_3 = { class: "appeal-box-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备故障照片", -1))
const _hoisted_5 = { class: "appeal-box-other" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "appeal-box-othertitle" }, "照片要求", -1))
const _hoisted_7 = { class: "appeal-image-count" }
const _hoisted_8 = { class: "appeal-box-imagelist" }
const _hoisted_9 = { class: "appeal-box-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appeal-tips" }, "请按照要求上传设备损坏的图片，以便快速进行人工审核。", -1))
const _hoisted_11 = { class: "appeal-box error-desc" }
const _hoisted_12 = { class: "appeal-box-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "故障描述", -1))
const _hoisted_14 = { class: "appeal-image-count" }
const _hoisted_15 = { class: "appeal-box error-log" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "飞行故障日志", -1))
const _hoisted_17 = { class: "appeal-errorlog" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选择", -1))
const _hoisted_19 = { class: "flight-loglist" }
const _hoisted_20 = { class: "confirm-fixed" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", {
    class: "appeal-page",
    style: _normalizeStyle({'padding-top': `${Number(_ctx.pagePaddingTop)}px`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, { title: "申诉" })
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_van_icon, {
                name: "question-o",
                class: "question-icon",
                size: "14"
              })
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.imagesGuidList.length) + "/9", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_uploader, {
              modelValue: _ctx.fileList,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
              multiple: "",
              "max-count": 9,
              "before-delete": _ctx.beforeDelete
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_van_icon, {
                    name: "plus",
                    class: "appeal-input-icon"
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "before-delete"])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.description.length) + "/200", 1)
          ]),
          _createVNode(_component_van_field, {
            class: "error-textarea",
            modelValue: _ctx.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
            modelModifiers: { trim: true },
            rows: "2",
            maxlength: "200",
            autosize: "",
            label: "",
            type: "textarea",
            placeholder: "请尽可能描述发生故障的情况，以便尽快解决问题。"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "appeal-box-title appeal-box-felxtitle",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSelectDatePage && _ctx.handleSelectDatePage(...args)))
          }, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_van_icon, {
                name: "arrow errorlog-icon",
                size: "16",
                color: "rgba(0,0,0,0.44)"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexSelectLog, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flight-logitem",
                key: index
              }, [
                _createElementVNode("span", null, _toDisplayString(item.name), 1),
                _createVNode(_component_van_icon, {
                  name: "cross",
                  class: "flight-icon",
                  size: "16"
                })
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        class: _normalizeClass({'repair-confirm-btn': true, 'btn-submit': _ctx.btnCanbeSubmit}),
        disabled: !_ctx.btnCanbeSubmit,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleAppealProtect && _ctx.handleAppealProtect(...args)))
      }, "提交", 10, _hoisted_21)
    ])
  ], 4))
}